import React from 'react'
import usePageMeta from '../hooks/usePageMeta'
import Navbar from '../components/navbar/Navbar'
import AboutHeader from '../components/header_about/AboutHeader'
import About from '../components/about/About'
import Footer from '../components/footer/Footer'

export default function AboutPage() {
  usePageMeta({
    title: 'About Our Preschool | Learning In Motion Academy, Tamarac FL',
    description: 'Meet the team behind Learning In Motion Academy, a Gold Seal accredited preschool in Tamarac, FL serving families since day one.',
    path: '/about',
  })

  return (
    <>
      <Navbar/>
      <AboutHeader/>
      <About/>
      <Footer/>
    </>
  )
}
